import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VendorBookings from "../components/VendorBookings";

const VendorBookingsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title='My Bookings History' />

                <VendorBookings />

            </MasterLayout>

        </>
    );
};

export default VendorBookingsPage;
